import { DocumentNode } from 'graphql';
import { Form, MostActionConfigJobFormProps } from './types';
import { useTranslation } from 'react-i18next';
import { useRunCommand } from 'src/hooks/query/use-run-command';
import { ActionConfigForm } from './action-config';

type MostRunJobFormProps = Omit<MostActionConfigJobFormProps, 'onSubmit'> & {
  refetchQueries?: DocumentNode[];
  onFinish: () => void;
};

export const RunJobForm = ({
  refetchQueries,
  onFinish,
  ...rest
}: MostRunJobFormProps) => {
  const { t } = useTranslation(undefined, {
    keyPrefix: 'most.list.run.form',
  });

  const { submitJobConfig } = useRunCommand();

  const onSubmit = async ({ jobConfig }: Form) =>
    submitJobConfig(jobConfig as any, { refetchQueries, onFinish });

  return (
    <ActionConfigForm
      onSubmit={onSubmit}
      submitButtonLabel={t('submit')}
      hiddenFields={['callout', 'schedule', 'recurring']}
      {...rest}
    />
  );
};
